import http from './http'

export const getList = async () => {
  const request = http.getAuthed(`/marketplace/partnerships`)
  const response = await request
  return response
}

export const getDetails = async (partnershipId) => {
  const request = http.getAuthed(`/marketplace/partnerships/${partnershipId}`)
  const response = await request
  return response
}

export const removePartnership = async ({ id }) => {
  const request = http.postAuthed(`/marketplace/partnerships/${id}/delete`)
  const response = await request
  return response
}

export const DEFAULT_PROMO_LINK_URL_TEXT = 'Get discount'
export const DEFAULT_PROMO_CODE = 'Get promo code'
export const DEFAULT_MAIL_INTRO_TEXT = 'Get in touch'

export default {
  getList,
  getDetails,
  removePartnership,
  DEFAULT_PROMO_LINK_URL_TEXT,
  DEFAULT_PROMO_CODE,
  DEFAULT_MAIL_INTRO_TEXT,
}
